<template>
    <div class="card" v-if="loadForm">
        <div class="card-header bg-info" style="height: 50px; display: flex; align-items: center">
            <div style="font-size: 16px; color: #fff">{{ title }}</div>
        </div>
        <div class="card-body">
            <header class="clearfix" v-if="showHeaderForm">
                <header-form :company="company"
                             :establishment="establishment">
                </header-form>
            </header>
            <form autocomplete="off" @submit.prevent="submit">
                <div class="form-body">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group" :class="{'has-danger': errors.customer_id}">
                                        <label class="control-label font-weight-bold text-info">
                                            Cliente
                                            <a href="#" @click.prevent="showDialogNewPerson = true">[+ Nuevo]</a>
                                            <a href="#"
                                               v-if="form.customer_id"
                                               @click.prevent="showDialogDocuments = true">[Ver documentos]</a>
                                        </label>
                                        <el-select v-model="form.customer_id" filterable remote
                                                   class="border-left rounded-left border-info"
                                                   popper-class="el-select-customers"
                                                   dusk="customer_id"
                                                   placeholder="Escriba el nombre o número de documento del cliente"
                                                   :remote-method="searchRemoteCustomers"
                                                   :loading="loading_search"
                                                   @change="changeCustomer"
                                                   @keyup.enter.native="keyupCustomer">

                                            <el-option v-for="option in customers" :key="option.id" :value="option.id"
                                                       :label="option.description"></el-option>

                                        </el-select>
                                        <small class="form-control-feedback" v-if="errors.customer_id"
                                               v-text="errors.customer_id[0]"></small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <x-input label="Dirección de envío"
                                             v-model="form.shipping_address"></x-input>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-12">
                                    <div class="form-group" :class="{'has-danger': errors.observations}">
                                        <label class="control-label">Observaciones
                                        </label>
                                        <el-input type="textarea" :rows="3" v-model="form.observations"></el-input>
                                        <small class="form-control-feedback" v-if="errors.observations"
                                               v-text="errors.observations[0]"></small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="row">
                                <div class="col-lg-4">
                                    <div class="form-group" :class="{'has-danger': errors.date_of_issue}">
                                        <label class="control-label">Fec. Emisión</label>
                                        <el-date-picker v-model="form.date_of_issue"
                                                        type="date"
                                                        format="dd/MM/yyyy"
                                                        value-format="yyyy-MM-dd"
                                                        :clearable="false"
                                                        @change="changeDateOfIssue"></el-date-picker>
                                        <small class="form-control-feedback" v-if="errors.date_of_issue"
                                               v-text="errors.date_of_issue[0]"></small>
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <x-date-picker v-model="form.date_of_due"
                                                   label="Fec. Vencimiento"
                                                   :readonly="true"></x-date-picker>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group" :class="{'has-danger': errors.delivery_date}">
                                        <label class="control-label">Fec. Entrega</label>
                                        <el-date-picker v-model="form.delivery_date"
                                                        type="date"
                                                        format="dd/MM/yyyy"
                                                        value-format="yyyy-MM-dd"
                                                        :clearable="true"></el-date-picker>
                                        <small class="form-control-feedback" v-if="errors.delivery_date"
                                               v-text="errors.delivery_date[0]"></small>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-4">
                                    <x-select label="Moneda"
                                              v-model="form.currency_type_id"
                                              :options="currency_types"
                                              option-label="symbol"
                                              @input="changeCurrencyType"></x-select>
                                </div>
                                <div class="col-lg-4">
                                    <x-input label="Tipo de cambio"
                                             v-model="form.exchange_rate_sale"
                                             readonly></x-input>
                                </div>
                                <div class="col-lg-4">
                                    <x-select label="Vendedor"
                                              v-model="form.seller_id"
                                              :options="sellers"
                                              option-label="name"></x-select>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-12">
                                    <div>
                                        <label class="control-label">Datos adicionales</label>
                                        <a href="#" @click.prevent="clickAddAdditionalData"
                                           class="text-center font-weight-bold text-info">[+ Agregar]</a>
                                    </div>
                                    <div class="table-responsive">
                                        <table class="table"
                                               style="margin: 0" v-if="form && form.additional_data.length > 0">
                                            <thead>
                                            <tr>
                                                <th style="width: 160px; padding-left: 0">Título</th>
                                                <th>Descripción</th>
                                                <th style="width: 40px; padding-right: 0"></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(row, index) in form.additional_data" :key="index">
                                                <td style="padding: 0 2px 0 0">
                                                    <x-select v-model="row.title"
                                                              :options="aditional_titles"
                                                              option-label="label"
                                                              option-value="value"></x-select>
                                                </td>
                                                <td style="padding: 0 2px 0 0">
                                                    <x-input v-model="row.description"></x-input>
                                                </td>
                                                <td class="text-right" style="padding: 0 0 0 0">
                                                    <button type="button"
                                                            class="btn waves-effect waves-light btn-xs btn-danger"
                                                            @click.prevent="clickDeleteAdditionalData(index)">x
                                                    </button>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th width="5%">#</th>
                                        <th class="font-weight-bold"
                                            width="30%">Descripción
                                        </th>
                                        <th width="8%" class="text-center font-weight-bold">Unidad</th>
                                        <th width="8%" class="text-center font-weight-bold">Cantidad</th>
                                        <th class="text-center font-weight-bold">Valor Unitario</th>
                                        <th class="text-center font-weight-bold">Precio Unitario</th>
                                        <th class="text-center font-weight-bold">Subtotal</th>
                                        <!--<th class="text-right font-weight-bold">Cargo</th>-->
                                        <th class="text-center font-weight-bold">Total</th>
                                        <th width="8%" v-if="showItemButtonAction"></th>
                                    </tr>
                                    </thead>
                                    <tbody v-if="form.items.length > 0">
                                    <tr v-for="(row, index) in form.items" :key="index">
                                        <td>{{ index + 1 }}</td>
                                        <td>
                                            {{ setDescriptionOfItem(row.item) }}
                                            {{
                                                row.item.presentation.hasOwnProperty('description') ? row.item.presentation.description : ''
                                            }}<br/><small>{{ row.affectation_igv_type.description }}</small>
                                            <template v-if="row.lots && row.lots.length > 0">
                                                <br/>Series: {{ showItemSeries(row.lots) }}
                                            </template>
                                        </td>
                                        <td class="text-center">{{ row.item.unit_type_id }}</td>
                                        <td class="text-center">{{ row.quantity }}</td>
                                        <td class="text-center">{{ currency_type.symbol }}
                                            {{ getFormatUnitPriceRow(row.unit_value) }}
                                        </td>
                                        <td class="text-center">{{ currency_type.symbol }}
                                            {{ getFormatUnitPriceRow(row.unit_price) }}
                                        </td>
                                        <td class="text-center">{{ currency_type.symbol }} {{ row.total_value }}</td>
                                        <td class="text-center">{{ currency_type.symbol }} {{ row.total }}</td>
                                        <td class="text-center" v-if="showItemButtonAction">
                                            <button type="button"
                                                    class="btn waves-effect waves-light btn-xs btn-info"
                                                    @click="ediItem(row, index)"><span style='font-size:10px;'>&#9998;</span>
                                            </button>
                                            <button type="button"
                                                    class="btn waves-effect waves-light btn-xs btn-danger"
                                                    @click.prevent="clickRemoveItem(index)">x
                                            </button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td :colspan="is_generate_from_quotation ? 9 : 8"></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-12 col-md-4">
                            <x-button-primary text="+ Agregar Producto"
                                              v-if="showItemButtonAction"
                                              @click="showDialogAddItem = true"></x-button-primary>
                        </div>
                        <div class="col-12 col-md-8">
                            <table class="table table-sm text-right" v-if="form && form.items.length > 0">
                                <tbody>
                                <tr v-if="enabled_discount_global">
                                    <td>DESCUENTOS (-)</td>
                                    <td>:</td>
                                    <td>
                                        <x-select v-model="discount_global_type"
                                                  :options="[{'id': '01', 'name': currency_type.symbol}, {'id': '02', 'name': '%'}]"
                                                  :disable="!showItemButtonAction"
                                                  @input="changeDiscountGlobalType">
                                        </x-select>
                                    </td>
                                    <td>
                                        <el-input-number v-model="discount_global_amount"
                                                         :min="0"
                                                         class="input-custom"
                                                         controls-position="right"
                                                         :disabled="!showItemButtonAction"
                                                         @change="calculateTotal"></el-input-number>
                                    </td>
                                </tr>
                                <tr v-if="form.total_exportation > 0">
                                    <td>OP.EXPORTACIÓN</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.total_exportation }}</td>
                                </tr>
                                <tr v-if="form.total_free > 0">
                                    <td>OP.GRATUITAS</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.total_free }}</td>
                                </tr>
                                <tr v-if="form.total_unaffected > 0">
                                    <td>OP.INAFECTAS</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.total_unaffected }}</td>
                                </tr>
                                <tr v-if="form.total_exonerated > 0">
                                    <td>OP.EXONERADAS</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.total_exonerated }}</td>
                                </tr>
                                <tr v-if="form.total_taxed > 0">
                                    <td>OP.GRAVADA</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.total_taxed }}</td>
                                </tr>
                                <tr>
                                    <td>SUBTOTAL</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.subtotal }}</td>
                                </tr>
                                <tr>
                                    <td>IGV</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.total_igv }}</td>
                                </tr>
                                <tr v-if="form.total_isc > 0">
                                    <td>ISC</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.total_isc }}</td>
                                </tr>
                                <tr v-if="form.total_plastic_bag_taxes > 0">
                                    <td>ICBPER</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.total_plastic_bag_taxes }}</td>
                                </tr>
                                <tr>
                                    <td style="font-weight: bolder; font-size: 18px; padding: 16px 0;">TOTAL A PAGAR</td>
                                    <td style="font-weight: bolder; font-size: 18px; padding: 16px 0; width: 40px!important;">:</td>
                                    <td style="font-weight: bolder; font-size: 18px; padding: 16px 0; width: 80px!important;">
                                        {{ currency_type.symbol }}
                                    </td>
                                    <td style="font-weight: bolder; font-size: 18px; padding: 16px 0; width: 120px!important;">{{ form.total_payment }}</td>
                                </tr>
                                <tr v-if="form.total > 0">
                                    <td>CONDICIÓN DE PAGO</td>
                                    <td class="text-left">:</td>
                                    <td colspan="2">
                                        <x-select v-model="form.payment_condition_id"
                                                  :options="payment_conditions"
                                                  @input="changePaymentCondition"></x-select>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="form-actions text-right mt-4">
                    <el-button @click.prevent="close()">Cancelar</el-button>
                    <el-button class="submit" type="primary" native-type="submit" :loading="loading_submit"
                               v-if="form.items.length > 0">Generar
                    </el-button>
                </div>
            </form>
        </div>

        <order-note-item :showDialog.sync="showDialogAddItem"
                         :typeUser="typeUser"
                         :configuration="config"
                         :currency-types="currency_types"
                         :currency-type-id-active="form.currency_type_id"
                         :exchange-rate-sale="form.exchange_rate_sale"
                         :recordItem="recordItem"
                         :customer-id="form.customer_id"
                         :percentage-igv="percentage_igv"
                         :show-option-change-currency="true"
                         :table="resource"
                         @add="addRow"></order-note-item>

        <person-form :showDialog.sync="showDialogNewPerson"
                     type="customers"
                     :external="true"
                     :input_person="input_person"
                     :document_type_id=form.document_type_id
                     @success="successPerson"></person-form>

        <store-finish :showDialog.sync="showDialogOptions"
                      :typeUser="typeUser"
                      :record-data="recordData"
                      :resource="resource"
                      :parent-table="parentTable"
                      :show-new="showNew"
                      :configuration="config"></store-finish>

        <store-document-items :show-dialog.sync="showDialogDocuments"
                              :resource="resource"
                              table="order_notes"
                              document-type-id="U6"
                              :person-id="form.customer_id"
                              @success="successDocuments"></store-document-items>
    </div>
</template>

<script>
import OrderNoteItem from '../Documents/partials/item.vue'
import PersonForm from '../persons/form.vue'
import StoreFinish from '../Store/Finish.vue'
import {functions, exchangeRate} from '@mixins/functions'
import {calculateRowItem, showNamePdfOfDescription} from '@helpers/functions'
import Logo from '../companies/logo.vue'
import {mapActions, mapState} from "vuex";
import SelectLotsGroup from '../Documents/partials/lots_group.vue'
import HeaderForm from "../../../components/Form/HeaderForm";
import StoreDocumentItems from "../Store/DocumentItems.vue";
import XSelect from "../../../components/Form/XSelect.vue";
import {fCalculateDiscountGlobal, fCalculateTotal} from "../../../helpers/functions";
import QuotationFormItem from "../Documents/partials/item.vue";
import XInput from "../../../components/Form/XInput.vue";
import XDatePicker from "../../../components/Form/XDatePicker.vue";
import moment from "moment";
import XButtonPrimary from "../../../components/Form/XButtonPrimary.vue";
import QuotationOptions from "../Store/Finish.vue";

export default {
    props: [
        'orderNoteId',
        'typeUser',
        'configuration',
        'parentTable',
        'parentId',
        'action'
    ],
    components: {
        QuotationOptions,
        XButtonPrimary,
        XDatePicker,
        XInput,
        QuotationFormItem,
        XSelect,
        StoreDocumentItems, HeaderForm, OrderNoteItem, PersonForm, StoreFinish, Logo, SelectLotsGroup
    },
    mixins: [functions, exchangeRate],
    data() {
        return {
            title: null,
            resource: 'order_notes',
            showDialogAddItem: false,
            showDialogNewPerson: false,
            showDialogOptions: false,
            showDialogDocuments: false,
            loading_submit: false,
            loading_form: false,
            errors: {},
            form: {},
            sellers: [],
            currency_types: [],
            discount_types: [],
            charges_types: [],
            all_customers: [],
            payment_conditions: [],
            payment_method_types: [],
            customers: [],
            establishments: [],
            currency_type: {},
            activePanel: 0,
            loading_search: false,
            is_generate_from_quotation: false,
            current_index_item: -1,
            lots_group_quantity: 0,
            showDialogLotsGroup: false,
            lots_group: [],
            input_person: {},
            aditional_titles: [{
                value: 'INGRESO',
                label: 'INGRESO'
            }, {
                value: 'ENTREGA',
                label: 'ENTREGA'
            }, {
                value: 'DOCUMENTO',
                label: 'DOCUMENTO'
            }, {
                value: 'CONTACTO',
                label: 'CONTACTO'
            }, {
                value: 'CELULAR',
                label: 'CELULAR'
            }, {
                value: 'TRANSPORTE',
                label: 'TRANSPORTE'
            }, {
                value: 'FORMA DE PAGO',
                label: 'FORMA DE PAGO'
            }, {
                value: 'COORDENADAS',
                label: 'COORDENADAS'
            }],
            payment_destinations: [],
            showHeaderForm: false,
            loadForm: false,
            discount_type: null,
            discount_amount: null,
            discount_global_type: '01',
            discount_global_amount: 0,
            recordItem: null,
            total_discount_no_base: 0,
            enabled_discount_global: false,
            company: null,
            recordData: null,
            establishmentId: null,
            sellerId: null,
            showNew: false,
        }
    },
    created() {
        this.loadConfiguration()
        this.$store.commit('setConfiguration', this.configuration)
        this.initForm()
        // this.loadEstablishment()
        // this.loadCompany()
    },
    async mounted() {
        this.$eventHub.$on('reloadDataPersons', (customer_id) => {
            this.reloadDataCustomers(customer_id)
        })
        this.$eventHub.$on('initInputPerson', () => {
            this.initInputPerson()
        });
        await this.$http.get(`/store/get_tables`)
            .then(response => {
                const data = response.data
                this.currency_types = data.currency_types
                this.all_customers = data.customers
                this.discount_types = data.discount_types
                this.charges_types = data.charges_types
                this.company = data.company
                this.payment_conditions = data.payment_conditions
                this.payment_method_types = data.payment_method_types
                this.payment_destinations = data.payment_destinations
                this.enabled_discount_global = data.enabled_discount_global
                this.showHeaderForm = data.show_header_form
                this.sellers = data.sellers
                this.sellerId = data.seller_id
                this.establishmentId = data.establishment_id
            })

        this.initFormData()

        await this.getPercentageIgv()

        if (this.parentTable) {
            let url = `/store/record/${this.parentTable}/${this.parentId}/${this.resource}`
            if (this.action) {
                url += `/${this.action}`
            }
            await this.$http.get(url)
                .then(response => {
                    let data = response.data
                    this.form = Object.assign({}, this.form, data.form)
                    let its = []
                    data.items.forEach((row) => {
                        its.push(calculateRowItem(row, this.percentage_igv))
                    })
                    this.form.items = its
                    this.customers = data.persons
                    this.discount_global_type = data.general.discount_global_type
                    this.discount_global_amount = data.general.discount_global_amount
                    this.calculateTotal()
                })
            this.currency_type = this.currency_types.find(row => row.id === this.form.currency_type_id)
        } else {
            // this.changeEstablishment()
            await this.changeDateOfIssue()
            this.changeCurrencyType()
            this.allCustomers()
        }
        // if (this.orderNoteId) {
        //
        // } else {
        //     if (this.table) {
        //         await this.$http.get(`/store/record/${this.table}/${this.tableId}/order_notes`)
        //             .then(response => {
        //                 let data = response.data
        //                 this.form = Object.assign({}, this.form, data.form)
        //                 let its = []
        //                 data.items.forEach((row) => {
        //                     its.push(calculateRowItem(row, this.form.currency_type_id, this.form.exchange_rate_sale, this.percentage_igv))
        //                 })
        //                 this.form.items = its
        //                 this.customers = data.persons
        //                 this.discount_global_type = data.general.discount_global_type
        //                 this.discount_global_amount = data.general.discount_global_amount
        //                 this.calculateTotal()
        //             })
        //             .finally(() => this.loading_submit = false)
        //         this.currency_type = this.currency_types.find(row => row.id === this.form.currency_type_id)
        //     } else {
        //         this.changeEstablishment()
        //         await this.changeDateOfIssue()
        //         this.changeCurrencyType()
        //         this.allCustomers()
        //     }
        // }

        if(this.action === 'new' || this.action === 'duplicate') {
            this.showNew = true
        }

        this.title = 'Nuevo pedido'
        if (this.form.id) {
            this.title = 'Editar pedido'
        }
        this.loadForm = true
        this.loading_form = true
    },
    computed: {
        ...mapState([
            'config',
        ]),
        showItemButtonAction() {
            return (this.action === 'new' && this.parentTable === null) || this.action === 'edit' || this.action === 'duplicate'
        },
    },
    methods: {
        clickAddAdditionalData() {
            this.form.additional_data.push({
                title: null,
                description: null,
            })
        },
        clickDeleteAdditionalData(index) {
            this.form.additional_data.splice(index, 1)
        },
        addRowLotGroup(lots_selecteds) {

            this.form.items[this.current_index_item].IdLoteSelected = lots_selecteds
            this.current_index_item = -1

        },
        regularizeCompromiseQuantity(row) {

            if (row.IdLoteSelected) {
                this.lots_group.forEach(l_group => {

                    const lot = _.find(row.IdLoteSelected, {id: l_group.id})

                    if (lot) l_group.compromise_quantity = lot.compromise_quantity

                })
            }

        },
        async getLotsGroup(item_id) {

            this.loading = true

            await this.$http.get(`/item-lots-group/available-data/${item_id}`)
                .then((response) => {
                    this.lots_group = response.data
                })
                .then(() => {
                    this.loading = false
                })

        },
        async openDialogLotsGroup(index, row) {

            await this.getLotsGroup(row.item_id)
            await this.regularizeCompromiseQuantity(row)
            this.current_index_item = index
            this.lots_group_quantity = row.quantity
            this.showDialogLotsGroup = true

        },
        ...mapActions([
            'loadConfiguration',
            'loadCompany',
            'loadEstablishment',
        ]),
        changeCustomer() {
            this.setAddressByCustomer()
        },
        setAddressByCustomer() {

            let customer = _.find(this.customers, {id: this.form.customer_id})

            if (customer) {
                this.form.shipping_address = customer.address
            }

        },
        getFormatUnitPriceRow(unit_price) {
            return _.round(unit_price, 6)
            // return unit_price.toFixed(6)
        },
        async changePaymentMethodType(flag_submit = true) {
            let payment_method_type = await _.find(this.payment_method_types, {'id': this.form.payment_method_type_id})
            if (payment_method_type) {

                if (payment_method_type.number_days) {
                    this.form.date_of_issue = moment().add(payment_method_type.number_days, 'days').format('YYYY-MM-DD');
                    this.changeDateOfIssue()
                }
                // else{
                //     if(flag_submit){
                //         this.form.date_of_issue = moment().format('YYYY-MM-DD')
                //         this.changeDateOfIssue()
                //     }
                // }
            }
        },
        searchRemoteCustomers(input) {

            if (input.length > 0) {
                this.loading_search = true
                let parameters = `input=${input}`

                this.$http.get(`/${this.resource}/search/customers?${parameters}`)
                    .then(response => {
                        this.customers = response.data.customers
                        this.loading_search = false
                        /* if (this.customers.length == 0) {
                            this.allCustomers()
                        } */
                        this.input_person.number = (this.customers.length == 0) ? input : null
                    })
            } else {
                this.allCustomers()
                this.input_person.number = null
            }

        },
        initForm() {
            this.errors = {}
            this.form = {
                prefix: 'PD',
                number: '#',
                establishment_id: null,
                date_of_issue: moment().format('YYYY-MM-DD'),
                time_of_issue: moment().format('HH:mm:ss'),
                date_of_due: moment().format('YYYY-MM-DD'),
                customer_id: null,
                currency_type_id: this.configuration.currency_type_id,
                purchase_order: null,
                exchange_rate_sale: 0,
                total_prepayment: 0,
                total_charge: 0,
                total_discount: 0,
                total_exportation: 0,
                total_free: 0,
                total_taxed: 0,
                total_unaffected: 0,
                total_exonerated: 0,
                total_igv_free: 0,
                total_igv: 0,
                total_base_isc: 0,
                total_isc: 0,
                total_base_other_taxes: 0,
                total_other_taxes: 0,
                total_taxes: 0,
                total_value: 0,
                subtotal: 0,
                seller_id: null,
                total: 0,
                operation_type_id: null,
                delivery_date: null,
                items: [],
                charges: [],
                discounts: [],
                attributes: [],
                guides: [],
                payment_condition_id: '01',
                payment_method_type_id: null,
                additional_information: null,
                shipping_address: null,
                actions: {
                    format_pdf: 'a4',
                },
                additional_data: [],
                prepayments: [],
            }
            this.is_generate_from_quotation = false
            this.initInputPerson()
        },
        initFormData() {
            this.form.establishment_id = this.establishmentId
            this.form.seller_id = this.sellerId
        },
        async resetForm() {
            this.activePanel = 0
            this.initForm()
            this.initFormData()
            // this.form.currency_type_id = (this.currency_types.length > 0) ? this.currency_types[0].id : null
            // this.form.establishment_id = (this.establishments.length > 0) ? this.establishments[0].id : null
            // this.changeEstablishment()
            await this.changeDateOfIssue()
            this.changeCurrencyType()
            this.allCustomers()
        },
        changeEstablishment() {
            let establishment = _.find(this.establishments, {'id': this.form.establishment_id})
            this.$store.commit('setEstablishment', establishment);
        },
        cleanCustomer() {
            this.form.customer_id = null;
        },
        async changeDateOfIssue() {
            await this.searchExchangeRateByDate(this.form.date_of_issue).then(response => {
                this.form.exchange_rate_sale = response
            })
            await this.getPercentageIgv();
            this.changeCurrencyType();
        },
        allCustomers() {
            this.customers = this.all_customers
        },
        addRow(row) {
            console.log('addRow')
            if (this.recordItem) {
                this.form.items[this.recordItem.indexi] = row
                this.recordItem = null
            } else {
                this.form.items.push(JSON.parse(JSON.stringify(row)))
            }
            this.calculateTotal()
        },
        clickRemoveItem(index) {
            this.form.items.splice(index, 1)
            this.calculateTotal()
        },
        changeCurrencyType() {
            console.log('changeCurrencyType')
            this.currency_type = _.find(this.currency_types, {'id': this.form.currency_type_id})
            let items = []
            this.form.items.forEach((row) => {
                if (row.currency_type_id === 'PEN' && this.form.currency_type_id === 'USD') {
                    row.unit_price = row.unit_price / this.form.exchange_rate_sale
                }
                if (row.currency_type_id === 'USD' && this.form.currency_type_id === 'PEN') {
                    row.unit_price = row.unit_price * this.form.exchange_rate_sale
                }
                row.currency_type_id = this.form.currency_type_id
                items.push(calculateRowItem(row, this.percentage_igv))
            });
            this.form.items = items
            this.calculateTotal()
        },
        calculateTotal() {
            console.log('calculateTotal')
            this.form = Object.assign({}, this.form, fCalculateTotal(this.form))
            this.calculateDiscountGlobal()

            // let total_discount = 0
            // let total_charge = 0
            // let total_exportation = 0
            // let total_taxed = 0
            // let total_exonerated = 0
            // let total_unaffected = 0
            // let total_free = 0
            // let total_igv = 0
            // let total_value = 0
            // let total = 0
            // let total_igv_free = 0
            //
            // this.form.items.forEach((row) => {
            //     total_discount += parseFloat(row.total_discount)
            //     total_charge += parseFloat(row.total_charge)
            //
            //     if (row.affectation_igv_type_id === '10') {
            //         total_taxed += parseFloat(row.total_value)
            //     }
            //     // if (row.affectation_igv_type_id === '20') {
            //     //     total_exonerated += parseFloat(row.total_value)
            //     // }
            //     if (row.affectation_igv_type_id === '30') {
            //         total_unaffected += parseFloat(row.total_value)
            //     }
            //     if (row.affectation_igv_type_id === '40') {
            //         total_exportation += parseFloat(row.total_value)
            //     }
            //     // if (['10', '20', '30', '40'].indexOf(row.affectation_igv_type_id) < 0) {
            //     //     total_free += parseFloat(row.total_value)
            //     // }
            //     // if (['10', '20', '30', '40'].indexOf(row.affectation_igv_type_id) > -1) {
            //     //     total_igv += parseFloat(row.total_igv)
            //     //     total += parseFloat(row.total)
            //     // }
            //
            //     if (
            //         row.affectation_igv_type_id === '20'  // 20,Exonerado - Operación Onerosa
            //         // || row.affectation_igv_type_id === '21' // 21,Exonerado – Transferencia Gratuita
            //     ) {
            //
            //         // total_exonerated += parseFloat(row.total_value)
            //
            //         total_exonerated += (row.total_value_without_rounding) ? parseFloat(row.total_value_without_rounding) : parseFloat(row.total_value)
            //     }
            //
            //
            //     if (
            //         row.affectation_igv_type_id === '30'  // 30,Inafecto - Operación Onerosa
            //         //|| row.affectation_igv_type_id === '31'  // 31,Inafecto – Retiro por Bonificación
            //         || row.affectation_igv_type_id === '32'  // 32,Inafecto – Retiro
            //         || row.affectation_igv_type_id === '33'  // 33,Inafecto – Retiro por Muestras Médicas
            //         || row.affectation_igv_type_id === '34'  // 34,Inafecto - Retiro por Convenio Colectivo
            //         || row.affectation_igv_type_id === '35'  // 35,Inafecto – Retiro por premio
            //         || row.affectation_igv_type_id === '36' // 36,Inafecto - Retiro por publicidad
            //         // || row.affectation_igv_type_id === '37'  // 37,Inafecto - Transferencia gratuita
            //     ) {
            //         total_unaffected += parseFloat(row.total_value)
            //     }
            //
            //     if (['10',
            //         // '20', '21',
            //         '20',
            //         '30', /*'31'*/ '32', '33', '34', '35', '36',
            //         '40'].indexOf(row.affectation_igv_type_id) < 0) {
            //         total_free += parseFloat(row.total_value)
            //     }
            //     if (['10',
            //         '20', '21',
            //         '30', '31', '32', '33', '34', '35', '36',
            //         '40'].indexOf(row.affectation_igv_type_id) > -1) {
            //         // total_igv += parseFloat(row.total_igv)
            //         // total += parseFloat(row.total)
            //         if (row.total_igv_without_rounding) {
            //             total_igv += parseFloat(row.total_igv_without_rounding)
            //         } else {
            //             total_igv += parseFloat(row.total_igv)
            //         }
            //
            //         // row.total_value_without_rounding = total_value
            //         // row.total_base_igv_without_rounding = total_base_igv
            //         // row.total_igv_without_rounding = total_igv
            //         // row.total_taxes_without_rounding = total_taxes
            //         // row.total_without_rounding = total
            //
            //         if (row.total_without_rounding) {
            //             total += parseFloat(row.total_without_rounding)
            //         } else {
            //             total += parseFloat(row.total)
            //         }
            //
            //
            //     }
            //
            //     // total_value += parseFloat(row.total_value)
            //
            //     if (!['21', '37'].includes(row.affectation_igv_type_id)) {
            //         total_value += parseFloat(row.total_value)
            //     }
            //
            //     if (['11', '12', '13', '14', '15', '16'].includes(row.affectation_igv_type_id)) {
            //
            //         let unit_value = row.total_value / row.quantity
            //         let total_value_partial = unit_value * row.quantity
            //         row.total_taxes = row.total_value - total_value_partial
            //         row.total_igv = total_value_partial * (row.percentage_igv / 100)
            //         row.total_base_igv = total_value_partial
            //         total_value -= row.total_value
            //         total_igv_free += row.total_igv
            //
            //     }
            //
            // });
            //
            // this.form.total_igv_free = _.round(total_igv_free, 2)
            // this.form.total_exportation = _.round(total_exportation, 2)
            // this.form.total_taxed = _.round(total_taxed, 2)
            // this.form.total_exonerated = _.round(total_exonerated, 2)
            // this.form.total_unaffected = _.round(total_unaffected, 2)
            // this.form.total_free = _.round(total_free, 2)
            // this.form.total_igv = _.round(total_igv, 2)
            // this.form.total_value = _.round(total_value, 2)
            // this.form.total_taxes = _.round(total_igv, 2)
            // this.form.subtotal = _.round(total, 2)
            // this.form.total = _.round(total, 2)
        },
        calculateDiscountGlobal() {
            console.log('calculateDiscountGlobal')
            this.form = Object.assign({}, this.form,
                fCalculateDiscountGlobal(this.form, this.enabled_discount_global, this.discount_global_type, this.discount_global_amount))
            // this.calculateDetraction()
            // this.calculateRetention()
            // this.setTotalPointsBySale(this.config)
            this.getTotal();
        },
        changeDiscountGlobalType() {
            console.log('changeDiscountGlobalType')
            this.calculateDiscountGlobal()
        },
        getTotal() {
            console.log('getTotal')
            let total = parseFloat(this.form.total)
            // let total_retention = parseFloat(this.form.total_retention)
            // let total_detraction = parseFloat(this.form.total_detraction)

            this.form.total_payment = _.round(total, 2).toFixed(2)
        },
        async validateQuantityLotsGroup() {

            let error_lots_group = 0

            await this.form.items.forEach((element) => {

                if (element.item.lots_enabled) {
                    if (!element.IdLoteSelected) error_lots_group++
                }

            });

            if (error_lots_group > 0) {
                return {
                    success: false,
                    message: 'Las cantidades y lotes seleccionados deben ser iguales.',
                }
            }

            return {success: true}
        },

        async submit() {

            if (this.form.date_of_issue > this.form.date_of_due)
                return this.$message.error('La fecha de emisión no puede ser posterior a la de vencimiento');

            if (this.form.date_of_issue > this.form.delivery_date)
                return this.$message.error('La fecha de emisión no puede ser posterior a la de entrega');


            if (this.is_generate_from_quotation) {
                const validate_items = await this.validateQuantityLotsGroup();
                if (!validate_items.success) return this.$message.error(validate_items.message)
            }

            this.loading_submit = true
            let url = this.orderNoteId ? `/${this.resource}/update` : `/${this.resource}`
            await this.$http.post(url, this.form)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                        this.resetForm()
                        this.recordData = response.data.data
                        this.showDialogOptions = true
                    } else {
                        this.$message.error(response.data.message)
                    }
                }).catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data;
                    } else {
                        this.$message.error(error.response.data.message);
                    }
                }).finally(() => {
                    this.loading_submit = false
                });
        },
        close() {
            location.href = `/${this.resource}`
        },
        reloadDataCustomers(customer_id) {
            this.$http.get(`/${this.resource}/search/customer/${customer_id}`).then((response) => {
                this.customers = response.data.customers
                this.form.customer_id = customer_id
                this.setAddressByCustomer()
            })
        },
        setDescriptionOfItem(item) {
            return showNamePdfOfDescription(item, this.config.show_pdf_name)
        },
        keyupCustomer() {

            if (this.input_person.number) {

                if (!isNaN(parseInt(this.input_person.number))) {

                    switch (this.input_person.number.length) {
                        case 8:
                            this.input_person.identity_document_type_id = '1'
                            this.showDialogNewPerson = true
                            break;

                        case 11:
                            this.input_person.identity_document_type_id = '6'
                            this.showDialogNewPerson = true
                            break;
                        default:
                            this.input_person.identity_document_type_id = '6'
                            this.showDialogNewPerson = true
                            break;
                    }
                }
            }
        },
        initInputPerson() {
            this.input_person = {
                number: null,
                identity_document_type_id: null
            }
        },
        successDocuments(items) {
            _.forEach(items, it => {
                this.form.items.push(it)
            })
        },
        changePaymentCondition() {
            console.log('changePaymentCondition')
            if (!['01', '02'].includes(this.form.payment_condition_id)) {
                let pc = _.find(this.payment_conditions, {'id': this.form.payment_condition_id});
                this.form.date_of_due = moment(this.form.date_of_issue).add(pc.days, 'days').format('YYYY-MM-DD');
            } else {
                this.form.date_of_due = moment(this.form.date_of_issue).format('YYYY-MM-DD');
            }
        },
        ediItem(row, index) {
            console.log('ediItem')
            row.indexi = index
            this.recordItem = row
            this.showDialogAddItem = true
        },
        clickAddItem() {
            this.recordItem = null
            this.showDialogAddItem = true
        },
        showItemSeries(series) {
            console.log('showItemSeries')
            return series.map(o => o['series']).join(', ')
        },
        successPerson(data) {
            this.form.customer_id = data.id
            this.customers = data.data
            this.changeCustomer()
        },
    },
}
</script>
